export default __webpack_public_path__ + "static/media/team1.4e5d7b53.jpg";